import { createContext, useContext } from "react";

/**
 * The claims ticked in the claims list, shared between the list and the tab-actions row
 * above it — they are rendered into sibling slots of the tab scaffold, so neither can hold the state
 * for the other.
 */
export interface ClaimSelectionContextValue {
  selectedClaimIds: ReadonlySet<string>;
  setSelectedClaimIds: (claimIds: Set<string>) => void;
  clearSelection: () => void;
}

export const ClaimSelectionContext = createContext<ClaimSelectionContextValue | null>(null);

/**
 * Null where no provider is mounted. Selecting claims serves the staff-only bulk actions, so the
 * portal deliberately mounts none and its list renders without a selection column.
 */
export function useOptionalClaimSelection(): ClaimSelectionContextValue | null {
  return useContext(ClaimSelectionContext);
}
